<template>
  <div class="scancard-container">

    <div class="scancard" v-if="responses && responses[0].type !=='error'">
      <h3 class="title">BRAVO !!!</h3>
      <div class="user-text" v-if="user_scanned">Tu as scanné <b>{{ user_scanned.name }}</b></div>
      <div class="mask-picture"><img width="100%" :src="mask.icon" alt=""></div>
      <div class="mask-name">Découvre le masque <b>{{ mask.name }} {{ texture.name }}</b></div>
      <p class="scanpoint"><b>+{{ scanPoint }}</b> pts</p>
      <div class="button-container">
        <div @click="activeMask(false)" class="back">ANNULER</div>
        <router-link :to="'/masque/'+scancard.rawValue.split('/')[4]" class="mask">APPLIQUER</router-link>
      </div>
    </div>
    <div class="scancard" v-if="responses && responses[0].type==='error'">
      <h3 class="title">OOPS</h3>
      <p class="content_message">Il semblerait que ton qrcode ne soit pas ou plus valide</p>
      <div class="button-container">
        <div @click="activeMask(false)" class="back">Compris</div>
      </div>
    </div>
  </div>

</template>

<script>
import GamesFunctions from "../../../service"
import 'hooper/dist/hooper.css';
import {mapActions, mapState} from "vuex";

export default {
  name: 'Loader',
  props: {
    scancard: Object,
  },
  data() {
    return {
      maskExist: false,
      responses: null,
      scanPoint: 5,
      user_scanned: null,
      mask: null,
      texture: null,
    }
  },
  methods: {
    ...mapActions(['getMask']),
    activeMask(active) {
      if (active) {
        this.$emit('active-mask', {mask: this.mask, texture: this.texture})
      } else {
        this.$emit('active-mask', {})
      }
    },
    validScancard() {
      let urlScanned = this.scancard.rawValue
      let idSearch = urlScanned.hostname === 'animhead.fr' ? urlScanned.split('/')[4] : urlScanned.split('/')[3]


      this.getMask(idSearch).then(res => {
            this.responses = [res]
            if (res.value) {

              this.mask = res.value.mask
              this.texture = res.value.texture
              this.user_scanned = res.user

              this.scanPoint = 5
              //TODO : EVENT LIST
              //ADD SCANNED SOMEOME 5PTS USER_SCANNED ID

              //TODO : ADD SCANLIST id_user id_project_scanned id_user_scanned pts

              //TODO : GameCheck
              if (this.user.event_mask) {

                let today = new Date()
                let eventMaskDate = new Date(this.user.event_mask.end_date)
                if (today < eventMaskDate) {
                  GamesFunctions.checkGames(res)
                } else {
                  alert("Aie il semblerait que votre masque soit expiré, essayer d'en enregistrer un autre")

                }

              } else {

                alert("Vous n'avez pas encore enregistré votre tatouage")
              }
            }


          }
      )
    }
  },
  mounted() {
    this.validScancard()
  },
  watch: {
    responses: function (responses) {
      this.responses = responses
    }
  },
  computed: {
    ...mapState(['user'])
  }
}

</script>

<style>
.scancard-container {
  z-index: 1000;
  position: absolute;
  width: 100vw;
  height: 90vh;
  top: 0;
  left: 0;
  display: flex;
}

.scancard {
  text-align: center;
  padding: 20px;
  background: white;
  /*border:2px solid #00d6ff;*/
  border-radius: 20px;
  margin: auto;
  position: relative;
}

.scancard b {
  color: #00d6ff;
  text-transform: uppercase;
}

.scancard h3 {
  padding: 0;
  margin-top: 0;
  font-size: 2em;
  font-family: "Bebas Neue";
  color: #00d6ff;
}


.button-container {
  position: absolute;
  left: 0;
  bottom: -20px;
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.button-container > * {
  width: 40%;
}

.button-container div, .button-container a {
  padding: 10px 20px;
  border-radius: 10px;
  transition: .3s;
}

.button-container > *:hover {
  cursor: pointer;
}

.back {
  text-transform: uppercase;
  background: var(--main-red-color);
  border: 1px solid var(--main-red-color);
  color: #fff;
  transition: .3s;
}

.back:hover {
  background: var(--main-red-brightness);
  color: #fff;
}

.mask {
  border: 1px solid #00d6ff;
  background: #00d6ff;
  color: #fff;
  font-weight: bold;
}

.mask:hover {
  background: #fff;
  color: #00d6ff;
}


.mask-picture {
  margin: auto;
  width: 70%;
}

.form_response.error {
  width: 75%;
  margin: 15px auto auto auto;
  background-color: #ff3333;
  color: #fff;
  border-radius: 10px;
  /*position: absolute;*/
  /*font-family: "Bebas Neue";*/
}

.content_response {
  position: absolute;
  top: 0;
  width: 100%;
}

@media screen and (max-width: 750px) {
  .scancard {
    max-width: 80%;
  }
}

</style>
